import { Card, Typography, Box } from '@mui/material';
import ReactApexChart from 'react-apexcharts';
import formatMoney from 'src/utils/formatMoney';

// Monthly new-deal count + booked-TCV series across the trend window.
// Two y-axes: new_deals on a count axis, booked_tcv on a money axis.
export default function TrendsSection({ trends, currencyLabel }) {
  if (!trends) return null;
  const months = trends.months || [];

  const chart = {
    series: [
      { name: 'New Deals', type: 'column', data: trends.new_deals || [] },
      { name: 'Booked TCV', type: 'line', data: (trends.booked_tcv || []).map((v) => Number(v || 0)) },
    ],
    options: {
      chart: { type: 'line', toolbar: { show: false }, height: 340 },
      stroke: { width: [0, 3], curve: 'smooth' },
      plotOptions: { bar: { borderRadius: 4, columnWidth: '50%' } },
      colors: ['#1976d2', '#2e7d32'],
      dataLabels: { enabled: false },
      xaxis: { categories: months },
      yaxis: [
        { title: { text: 'New Deals' }, labels: { formatter: (v) => Math.round(v) } },
        {
          opposite: true,
          title: { text: 'Booked TCV' },
          labels: { formatter: (v) => formatMoney(v, currencyLabel) },
        },
      ],
      legend: { position: 'top' },
      tooltip: {
        y: {
          formatter: (v, { seriesIndex }) => (seriesIndex === 1 ? formatMoney(v, currencyLabel) : `${v} deals`),
        },
      },
    },
  };

  return (
    <Card sx={{ p: 2, mb: 3 }}>
      <Typography variant="h6" fontWeight={600} mb={1}>Trends</Typography>
      {months.length ? (
        <Box>
          <ReactApexChart options={chart.options} series={chart.series} type="line" height={340} />
        </Box>
      ) : (
        <Typography variant="body2" color="text.secondary">No trend data for this window.</Typography>
      )}
    </Card>
  );
}
